import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as Constants from '@emi/shared/constants';
import { clearSelections, DataExtractionState } from '@emi/shared/state/filters';
import { Store } from '@ngrx/store';

@Component({
  selector: 'via-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit, OnDestroy {

  public downloadsRoute: string = `${Constants.Routes.ACCOUNT_ROUTE}/${Constants.Routes.DOWNLOADS_ROUTE}`;

  constructor(private router: Router, private readonly store: Store<DataExtractionState>) { }

  private redirectToDownloadsPage = setTimeout(() => {
    this.goToDownloadsPage();
  }, 5000);

  public ngOnInit(): void {
    this.redirectToDownloadsPage;
  }

  public goToDownloadsPage(): void {
    if (window.location.href.includes(Constants.Routes.EXTRACT_APP_URL)) {
      this.router.navigateByUrl(this.downloadsRoute);
    } else {
      window.location.href = `/${Constants.Routes.EXTRACT_APP_URL}/#/${this.downloadsRoute}`;
    }
  }

  public ngOnDestroy(): void {
    this.store.dispatch(clearSelections());
    clearTimeout(this.redirectToDownloadsPage);
  }
}
